/* istanbul ignore file */
import { Route, AppId, createPageRoute } from '@lumapps/router';

export const contentBulkRoute: Route = createPageRoute({
    slug: 'all-content',
    appId: AppId.backOffice,
});

export const adminContentBulkRoute = (): Route => contentBulkRoute;
